import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPanelNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    id='panelNew_svg__Layer_1'
    x={0}
    y={0}
    viewBox='0 0 566.9 566.9'
    {...props}
  >
    <style>{'.panelNew_svg__st0{fill:currentColor}'}</style>
    <path
      d='M418.9 378.4c-33.1 45.8-82.4 70.1-135.4 70.1-91 0-164.7-73.7-164.7-164.7S192.6 119 283.5 119c53.7 0 101.4 25.7 131.5 65.5l10.7-7.6 85-59.6 1.2-.8c-19.1-26.1-42.7-48.9-69.6-67.2-7.4 4.7-14.9 9.1-22.5 13.5-1.9 1-4.6 1.6-7.2 1.6h-.6c-18.6-11-38.7-19.6-59.9-25.5 0-.1-.1-.1-.1-.2-1-1.3-1.6-2.9-1.9-4.9-1.7-8.9-3.6-17.7-5.6-26.5C325 3 304.7.7 283.8.7c-18.5 0-36.5 1.7-53.9 5.2-2.2 9.1-4.5 18.2-6.9 27.2-.4 1.3-1.1 3-2.3 4.3 0 .1 0 .1-.1.2-21.6 5.5-42.2 13.9-61.2 24.6h-.1c-.1 0-.2 0-.3-.1-1.7-.2-3.4-.6-4.5-1.3-8-4.9-16-9.9-23.8-14.9-32.4 20.9-60.2 48.2-81.6 80 4.7 7.5 9.4 15 14.1 22.4 1.2 1.8 1.9 3.6 2.2 5.2.1.1.1.2.1.3-11.4 19-20.4 39.7-26.4 61.6-.1 0-.1.1-.2.1-1.4 1-3.3 1.5-5.4 2-8.7 1.7-17.4 3.6-26.2 5.6C3 242.6.7 262.9.7 283.8c0 18.5 1.8 36.6 5.3 54.1 8.4 2 16.8 3.9 25.3 5.8 2.5.6 4.5 1.3 5.9 2.7.1 0 .2.1.3.2 5.4 21.4 13.6 41.6 24.2 60.5 0 .2 0 .5-.1.7-.2 2.3-1.1 4.5-2.7 6.9-4.7 7-9.3 14-13.9 21.1 20.7 32.6 47.9 60.6 79.7 82.2 7.4-4.6 14.8-9 22.2-13.3 5.9-3.5 7.3-2.3 9.1-1.2 18.5 10.9 38.5 19.4 59.6 25.2 0 .1.1.3.1.4.7 2.2 1.3 4.3 1.8 6.6 1.7 8.3 3.5 16.6 5.4 24.8 19.5 4.3 39.8 6.6 60.7 6.6 18.3 0 36.3-1.7 53.6-5.2 2.1-8.5 4-16.9 6-25.5.6-2.4 1.3-4.3 2.4-5.8.1-.2.2-.3.3-.4 22.2-5.6 43.2-14.1 62.6-25.2.2 0 .4.1.6.1 1.7.4 3.4 1.2 5.4 2.4 7.3 4.9 14.6 9.7 21.9 14.5 30.5-19.4 57.7-46.9 78.7-76.3z'
      className='panelNew_svg__st0'
    />
    <path
      d='M566.1 283.9c0 50.6-13.7 96.8-35.8 137.5L327.3 281l199.9-140c24.6 41.9 38.9 90.7 38.9 142.9'
      className='panelNew_svg__st0'
    />
  </svg>
);
export default SvgPanelNew;
